<template>
	<div class="select-stu-page" :class="{ visible: dialogVisible }">
		<el-dialog
			title="选择登记班级"
			:modal="false"
			:visible.sync="dialogVisible"
			:before-close="hideDialog"
			class="show-class-dialog"
			width="600"
		>
			<span slot="title">
				<span class="dialog-header-title">选择登记班级</span>
				<span class="dialog-header-tips">
					(不支持重复登记同日期学科下同班级的作业)
				</span>
			</span>
			<div class="dialog-pane">
				<div class="class-pane">
					<!-- 选取班级弹窗 -->
					<SelectMember :dialogVisible="dialogVisible" ref="selectMember" v-bind="$attrs" />
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="hideDialog">取 消</el-button>
					<el-button type="primary" @click="sureSel" :disabled="sendDisabled">确 定</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import SelectMember from "./selectMember";

	export default {
		name: "SelectStuDialog",
		components: {
			SelectMember,
		},
		props: ["dialogVisible"],
		data() {
			return {
				sendDisabled: false, // 是否禁用发送按钮
				classes: [],
			};
		},
		created() {},
		methods: {
			async sureSel() {
				// 最后选中的班级列表
				let classes = this.$refs.selectMember.getSelectedClasses();
				// console.log("classes--", classes);
				if (!classes.length) return;
				this.$emit("confirm", classes);
				return;
			},
			hideDialog() {
				this.$emit("hideDialog");
			},
		},
	};
</script>

<style lang="less" scoped>
	.select-stu-page {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: -10;
		transition: all 0.3s;
		&.visible {
			z-index: 2000;
			opacity: 1;
		}
		.dialog-pane {
			height: 100%;
			// padding-top: 18px;
		}
		.class-pane {
			height: 283px;
			// padding-left: 31px;
		}
	}
	::v-deep {
		.el-dialog {
			width: 480px;
			height: 427px;
			margin-top: 26vh !important;
		}
		.el-dialog__header {
			border-bottom: 1px solid #f2f2f2;
			padding: 16px 20px 14px;
		}
		.el-dialog__title {
			font-weight: 500;
			font-size: 20px;
			color: #000;
		}
		.el-dialog__body {
			padding: 0 0 30px;
		}
	}
	.dialog-footer {
		text-align: center;
		.el-button {
			width: 93px;
			height: 32px;
			border-radius: 3px;
			padding: 0;
			line-height: 32px;
			margin-top: 27px;
			// margin-left: 20px;
		}
	}
	.dialog-bot {
		width: 100%;
		margin: 18px 0 21px 0;
		padding: 0 20px 0 31px;
		font-size: 14px;
		font-family: Microsoft YaHei;
		font-weight: 500;
		color: #464646;
		::v-deep .el-checkbox__label {
			font-size: 14px;
			font-family: Microsoft YaHei;
			color: #464646;
		}
		::v-deep .el-input__inner {
			width: 169px;
			padding-right: 0;
			&:nth-of-type(1) {
				transform: translateY(-1px);
			}
		}
	}
	.show-class-dialog {
		background-color: rgba(0, 0, 0, 0.5);
		.dialog-header-title {
			font-weight: 500;
			font-size: 20px;
		}
		.dialog-header-tips {
			color: #ff2727;
		}
	}
</style>
